'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var mustache = require('mustache');
var ChevronIcon = require('@narvar/nth-bit-icon-chevron');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var AgentNavigatorProvider = require('../../../providers/AgentNavigatorProvider.js');
var ClaimDetailsProvider = require('../ClaimDetailsProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var ChevronIcon__default = /*#__PURE__*/_interopDefaultLegacy(ChevronIcon);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const ClaimDetailsBackLink = () => {
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const {
    navigateToOrderOverview
  } = AgentNavigatorProvider.useAgentNavigator();
  const {
    claimsClaimDetailsBackToOrder,
    claimsClaimDetailsBackToOrderIconText
  } = nthHookTranslations.useTranslations();
  const {
    orderNumber
  } = ClaimDetailsProvider.useClaimDetails();
  return /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: {
        ...linksNoneDefault,
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem'
      },
      sHover: linksNoneHover
    },
    onClick: () => navigateToOrderOverview({
      replace: true
    })
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    "aria-hidden": true
  }, /*#__PURE__*/React__default["default"].createElement(ChevronIcon__default["default"], {
    title: claimsClaimDetailsBackToOrderIconText ?? '',
    s: {
      width: '0.625rem',
      fill: 'currentColor'
    },
    direction: ChevronIcon.Direction.Left
  })), mustache__default["default"].render(claimsClaimDetailsBackToOrder ?? '', {
    orderNumber
  }));
};
var ClaimDetailsNav = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(ClaimDetailsBackLink, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['claimsClaimDetailsBackToOrder', 'claimsClaimDetailsBackToOrderIconText']
});

exports["default"] = ClaimDetailsNav;
